/* eslint import/prefer-default-export: "off" */
import _routes from './routes';

export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/index.js